// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Seed = require("./seed");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Counter = require("./counter");
var Network = require("./network");
var Storage = require("./storage");
var SvgAnim = require("./svgAnim");
var Counter2 = require("./counter2");
var Counter3 = require("./counter3");
var Step5box = require("./step5box");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var BeepMp3 = require("./assets/beep-07.mp3");
var Round_bgSvg = require("./assets/round_bg.svg");
var Info_iconSvg = require("./assets/info_icon.svg");
var Round_iconSvg = require("./assets/round_icon.svg");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");
var Congratulation_bgSvg = require("./assets/congratulation_bg.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var workout = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* [] */0
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.margin4(Css.px(10), Css.px(0), Css.px(2), Css.px(0)),
        /* [] */0
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var fullBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.boxSizing(/* borderBox */9307263),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var fullContainer = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(14), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var repEntryBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.margin4(Css.px(15), Css.px(0), Css.px(15), Css.px(0)),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList2 = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.backgroundImage(/* `url */[
              5843823,
              Round_bgSvg
            ]),
        /* :: */[
          Css.backgroundSize(Css.size(/* `percent */[
                    -119887163,
                    100.0
                  ], /* `percent */[
                    -119887163,
                    100.0
                  ])),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.marginTop(Css.px(20)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var headBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(Css.hex("fffafa")),
              /* :: */[
                Css.marginBottom(Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var infoHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
        /* [] */0
      ]
    ]);

var infoButton = Css.style(/* :: */[
      Css.position(/* absolute */-1013592457),
      /* :: */[
        Css.right(Css.px(12)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
            /* [] */0
          ]
        ]
      ]
    ]);

var infoIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.lineHeight(1.2),
        /* [] */0
      ]
    ]);

var repEntryText = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(25), Css.px(0), Css.px(25)),
      /* [] */0
    ]);

var weightEntryText = Css.style(/* :: */[
      Css.margin4(Css.px(20), Css.px(25), Css.px(20), Css.px(25)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* [] */0
      ]
    ]);

var finalText = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(10), Css.px(20), Css.px(10)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.maxWidth(Css.px(300)),
          /* [] */0
        ]
      ]
    ]);

var infoHeaderH2 = Css.style(/* :: */[
      Css.margin4(Css.px(3), Css.px(38), Css.px(3), Css.px(38)),
      /* :: */[
        Css.lineHeight(1.3),
        /* [] */0
      ]
    ]);

var infoHeaderH4 = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(2), Css.px(0)),
        /* [] */0
      ]
    ]);

var roundIconBox = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transforms(/* :: */[
              /* `translate */[
                -914368690,
                /* tuple */[
                  Css.px(0),
                  /* `percent */[
                    -119887163,
                    -50.0
                  ]
                ]
              ],
              /* :: */[
                /* `scale */[
                  -120664438,
                  /* tuple */[
                    1.4,
                    1.4
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(Css.px(0)),
            /* :: */[
              Css.top(Css.px(8)),
              /* :: */[
                Css.cursor(/* pointer */-786317123),
                /* :: */[
                  Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var roundIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var vertBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.margin4(Css.px(4), Css.px(0), Css.px(8), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.margin4(Css.px(4), Css.px(0), Css.px(8), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* [] */0
        ]
      ]
    ]);

var horizonBoxSmallEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* [] */0
      ]
    ]);

var initialBodyFrame = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.marginBottom(Css.px(5)),
          /* [] */0
        ]
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBodyVert = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBodyImgContainer = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(3), Css.px(1), Css.px(3)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.minWidth(Css.px(0)),
          /* :: */[
            Css.alignItems(/* center */98248149),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.maxWidth(/* `percent */[
            -119887163,
            100.0
          ]),
      /* [] */0
    ]);

var workoutNameHeader = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
            /* :: */[
              Css.margin4(Css.px(8), Css.px(8), Css.px(10), Css.px(8)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var countDown = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.fontSize(Css.px(36)),
            /* :: */[
              Css.fontWeight(700),
              /* :: */[
                Css.margin4(Css.px(8), Css.px(8), Css.px(10), Css.px(8)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
        /* [] */0
      ]
    ]);

var inputHeaderContainer = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.justifyContent(Css.center),
        /* :: */[
          Css.background(/* `hex */[
                5194459,
                "FFFAFA"
              ]),
          /* [] */0
        ]
      ]
    ]);

var weightInputHeaderContainer = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.justifyContent(Css.center),
        /* [] */0
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(10)),
      /* :: */[
        Css.marginTop(Css.px(10)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.background(/* `hex */[
                  5194459,
                  "FFFAFA"
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(0), Css.px(8), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(15)),
        /* :: */[
          Css.maxWidth(Css.px(120)),
          /* :: */[
            Css.fontSize(Css.px(28)),
            /* :: */[
              Css.borderRadius(/* `px */[
                    25096,
                    50
                  ]),
              /* :: */[
                Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                      5194459,
                      "F492BD"
                    ]),
                /* :: */[
                  Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                  /* :: */[
                    Css.boxSizing(/* borderBox */9307263),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var buttonContainer = Css.style(/* :: */[
      Css.marginBottom(Css.px(30)),
      /* :: */[
        Css.marginTop(Css.px(10)),
        /* [] */0
      ]
    ]);

var buttonContainerCentered = Css.style(/* :: */[
      Css.marginBottom(Css.px(30)),
      /* :: */[
        Css.marginTop(Css.px(10)),
        /* :: */[
          Css.justifyContent(/* center */98248149),
          /* [] */0
        ]
      ]
    ]);

var step5Box = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignSelf(/* stretch */-162316795),
          /* :: */[
            Css.borderRadius(Css.px(10)),
            /* :: */[
              Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
              /* :: */[
                Css.boxSizing(Css.borderBox),
                /* :: */[
                  Css.margin4(Css.px(10), Css.px(10), Css.px(20), Css.px(10)),
                  /* :: */[
                    Css.background(/* `linearGradient */[
                          616379637,
                          /* tuple */[
                            /* `deg */[
                              4995526,
                              180
                            ],
                            /* :: */[
                              /* tuple */[
                                0,
                                Css.hex("FFF8F9")
                              ],
                              /* :: */[
                                /* tuple */[
                                  50,
                                  Css.rgba(255, 255, 255, 0.0)
                                ],
                                /* :: */[
                                  /* tuple */[
                                    98,
                                    Css.hex("FFF8F9")
                                  ],
                                  /* [] */0
                                ]
                              ]
                            ]
                          ]
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var step5BoxInner1 = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
        /* :: */[
          Css.padding2(Css.px(0), Css.px(16)),
          /* :: */[
            Css.justifyContent(/* center */98248149),
            /* [] */0
          ]
        ]
      ]
    ]);

var step5BoxInner2 = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.background(/* `hex */[
                5194459,
                "FFFAFA"
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
            /* :: */[
              Css.padding2(Css.px(0), Css.px(10)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var middleText = Css.style(/* :: */[
      Css.margin2(Css.px(5), Css.px(0)),
      /* [] */0
    ]);

var step5BoxInner3 = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.position(/* relative */903134412),
            /* :: */[
              Css.marginTop(Css.px(20)),
              /* :: */[
                Css.marginBottom(Css.px(0)),
                /* :: */[
                  Css.paddingBottom(Css.px(20)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var congratsIcon = Css.style(/* :: */[
      Css.margin4(Css.px(4), Css.px(0), Css.px(20), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var finalVal = Css.style(/* :: */[
      Css.margin4(Css.px(4), Css.px(0), Css.px(20), Css.px(0)),
      /* :: */[
        Css.position(/* absolute */-1013592457),
        /* :: */[
          Css.top(Css.px(218)),
          /* :: */[
            Css.color(Css.white),
            /* :: */[
              Css.fontWeight(700),
              /* :: */[
                Css.fontSize(Css.px(22)),
                /* :: */[
                  Css.justifyContent(/* center */98248149),
                  /* :: */[
                    Css.width(/* `percent */[
                          -119887163,
                          100.0
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var someText = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin2(Css.px(10), Css.px(10)),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FF328C"
                  ]),
              /* :: */[
                Css.fontWeight(700),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* workout */workout,
  /* selectHeader */selectHeader,
  /* flexList */flexList,
  /* fullBox */fullBox,
  /* fullContainer */fullContainer,
  /* repEntryBox */repEntryBox,
  /* flexList2 */flexList2,
  /* headBox */headBox,
  /* infoHeader */infoHeader,
  /* infoButton */infoButton,
  /* infoIcon */infoIcon,
  /* infoHeaderH1 */infoHeaderH1,
  /* repEntryText */repEntryText,
  /* weightEntryText */weightEntryText,
  /* finalText */finalText,
  /* infoHeaderH2 */infoHeaderH2,
  /* infoHeaderH4 */infoHeaderH4,
  /* roundIconBox */roundIconBox,
  /* roundIcon */roundIcon,
  /* vertBox */vertBox,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* horizonBoxSmallEl */horizonBoxSmallEl,
  /* initialBodyFrame */initialBodyFrame,
  /* initialBody */initialBody,
  /* initialBodyVert */initialBodyVert,
  /* initialBodyImgContainer */initialBodyImgContainer,
  /* initialBodyImg */initialBodyImg,
  /* workoutNameHeader */workoutNameHeader,
  /* countDown */countDown,
  /* spanEl */spanEl,
  /* inputHeaderContainer */inputHeaderContainer,
  /* weightInputHeaderContainer */weightInputHeaderContainer,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* buttonContainer */buttonContainer,
  /* buttonContainerCentered */buttonContainerCentered,
  /* step5Box */step5Box,
  /* step5BoxInner1 */step5BoxInner1,
  /* step5BoxInner2 */step5BoxInner2,
  /* middleText */middleText,
  /* step5BoxInner3 */step5BoxInner3,
  /* congratsIcon */congratsIcon,
  /* finalVal */finalVal,
  /* someText */someText
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in workout component");
      return 0;
    } else {
      throw exn;
    }
  }
}

function checkForInt(x) {
  var x2 = convToInt(x);
  if (x2 >= 0 && x2 < 100) {
    return x2;
  } else {
    return 0;
  }
}

function checkForWeightInt(x) {
  var x2 = convToInt(x);
  if (x2 >= 0 && x2 < 200) {
    return x2;
  } else {
    return 0;
  }
}

function checkForWeightIntOpt(x) {
  var x2 = convToInt(x);
  if (x2 >= 0 && x2 < 220) {
    return /* Some */[x2];
  } else {
    return /* None */0;
  }
}

function turnBackToString(theInt) {
  if (theInt !== 0) {
    return String(theInt);
  } else {
    return "0";
  }
}

function text(prim) {
  return prim;
}

var $$window = (window);

var $$document = (document);

var JsAudio = /* module */[];

var component = ReasonReact.reducerComponent("Workout");

function make(week, workout$1, round, pair, step, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      window.scrollTo(0, 0);
      $$window.addEventListener("keydown", (function (ev) {
              var keyInt = ev.which;
              console.log("ev: ", ev.which);
              if (keyInt === 13) {
                console.log("ev13: ", ev.which);
                return Curry._1(self[/* send */4], /* EnterPress */1);
              } else {
                return 0;
              }
            }));
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var intPair = Caml_format.caml_int_of_string(pair);
      var currentEx1 = (intPair << 1) - 1 | 0;
      var currentEx2 = (intPair << 1);
      var exId = String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */7], (intPair << 1) - 2 | 0));
      var exIdInt = Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */7], (intPair << 1) - 2 | 0);
      var exLev = String(Caml_array.caml_array_get(self[/* state */2][/* levels */1], (intPair << 1) - 2 | 0));
      var exLevInt = Caml_array.caml_array_get(self[/* state */2][/* levels */1], (intPair << 1) - 2 | 0);
      var block22 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_b.jpg")))
                      }))));
      var block23 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_b.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_c.jpg"))),
                        onError: (function () {
                            return Curry._1(self[/* send */4], /* HideEl */Block.__(8, [1]));
                          })
                      }))));
      var block24 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_b.jpg")))
                      }))), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_c.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_d.jpg")))
                      }))));
      var block26 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId + ("_l" + (exLev + "_b.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_c.jpg")))
                      }))), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_d.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_e.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId + ("_l" + (exLev + "_f.jpg")))
                      }))));
      var match = self[/* state */2][/* running */26];
      var tmp;
      if (match !== 0) {
        var match$1 = self[/* state */2][/* showDetails23 */29];
        var tmp$1;
        if (match$1 !== 0) {
          var match$2 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exIdInt - 1 | 0), exLevInt - 1 | 0);
          var switcher = match$2 - 2 | 0;
          if (switcher > 4 || switcher < 0) {
            tmp$1 = block26;
          } else {
            switch (switcher) {
              case 0 : 
                  tmp$1 = block22;
                  break;
              case 1 : 
                  tmp$1 = block23;
                  break;
              case 2 : 
                  tmp$1 = block24;
                  break;
              case 3 : 
              case 4 : 
                  tmp$1 = block26;
                  break;
              
            }
          }
        } else {
          tmp$1 = null;
        }
        var match$3 = self[/* state */2][/* preRunning */27];
        tmp = React.createElement("div", {
              className: flexList
            }, React.createElement("div", {
                  className: initialBody
                }, tmp$1), React.createElement("div", {
                  className: flexList2
                }, React.createElement("div", {
                      className: countDown
                    }, match$3 !== 0 ? ReasonReact.element(/* None */0, /* None */0, Counter.make(self[/* state */2][/* preRunningCount */28], self[/* state */2][/* preRunningCount */28], /* true */1, /* array */[])) : ReasonReact.element(/* None */0, /* None */0, Counter3.make(self[/* state */2][/* duration */2], "Timer: ", self[/* state */2][/* count */30], /* false */0, /* array */[]))), React.createElement("div", {
                      className: buttonContainer
                    }, React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* SecondPair */6);
                            })
                        }, "Weiter"))));
      } else {
        var match$4 = self[/* state */2][/* showDetails23 */29];
        var tmp$2;
        if (match$4 !== 0) {
          var match$5 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exIdInt - 1 | 0), exLevInt - 1 | 0);
          var switcher$1 = match$5 - 2 | 0;
          if (switcher$1 > 4 || switcher$1 < 0) {
            tmp$2 = block26;
          } else {
            switch (switcher$1) {
              case 0 : 
                  tmp$2 = block22;
                  break;
              case 1 : 
                  tmp$2 = block23;
                  break;
              case 2 : 
                  tmp$2 = block24;
                  break;
              case 3 : 
              case 4 : 
                  tmp$2 = block26;
                  break;
              
            }
          }
        } else {
          tmp$2 = null;
        }
        var match$6 = self[/* state */2][/* showDetails23 */29];
        tmp = React.createElement("div", {
              className: flexList
            }, React.createElement("div", {
                  className: initialBodyVert
                }, tmp$2, match$6 !== 0 ? React.createElement("div", {
                        className: someText
                      }, React.createElement("span", {
                            dangerouslySetInnerHTML: {
                              __html: Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseDescriptions, exIdInt - 1 | 0)[/* description */1], exLevInt - 1 | 0)
                            }
                          })) : null), React.createElement("div", {
                  className: flexList2
                }, React.createElement("div", {
                      className: countDown
                    }, ReasonReact.element(/* None */0, /* None */0, Counter.make(self[/* state */2][/* duration */2], self[/* state */2][/* count */30], /* true */1, /* array */[]))), React.createElement("div", {
                      className: buttonContainer
                    }, React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* SetRunning */3);
                            })
                        }, "Start"))));
      }
      var step2 = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: fullBox
              }, React.createElement("div", {
                    className: fullContainer
                  }, React.createElement("div", {
                        className: headBox
                      }, React.createElement("div", {
                            className: roundIconBox
                          }, React.createElement("img", {
                                className: roundIcon,
                                alt: "round",
                                src: Round_iconSvg
                              })), React.createElement("h1", {
                            className: infoHeaderH1
                          }, "Runde " + round), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übungspaar " + (String(intPair) + " / 3")), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übung " + (String(currentEx1) + ""))), React.createElement("div", {
                        className: workoutNameHeader
                      }, React.createElement("h2", {
                            className: infoHeaderH2
                          }, Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 2 | 0)), React.createElement("div", {
                            className: infoButton,
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* ToggleDetails23 */0);
                              })
                          }, React.createElement("img", {
                                className: infoIcon,
                                alt: "info",
                                src: Info_iconSvg
                              }))), tmp)));
      var exId2 = String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */7], (intPair << 1) - 1 | 0));
      var exId2Int = Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */7], (intPair << 1) - 1 | 0);
      var exLev2 = String(Caml_array.caml_array_get(self[/* state */2][/* levels */1], (intPair << 1) - 1 | 0));
      var exLev2Int = Caml_array.caml_array_get(self[/* state */2][/* levels */1], (intPair << 1) - 1 | 0);
      var block32 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_b.jpg")))
                      }))));
      var block33 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_b.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_c.jpg"))),
                        onError: (function () {
                            return Curry._1(self[/* send */4], /* HideEl */Block.__(8, [1]));
                          })
                      }))));
      var block34 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_b.jpg")))
                      }))), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_c.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_d.jpg")))
                      }))));
      var block36 = React.createElement("div", {
            className: initialBodyFrame
          }, React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_a.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "image",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_b.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_c.jpg")))
                      }))), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_d.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_e.jpg")))
                      })), React.createElement("div", {
                    className: initialBodyImgContainer
                  }, React.createElement("img", {
                        className: initialBodyImg,
                        alt: "",
                        src: "/" + (exId2 + ("_l" + (exLev2 + "_f.jpg")))
                      }))));
      var match$7 = self[/* state */2][/* running */26];
      var tmp$3;
      if (match$7 !== 0) {
        var match$8 = self[/* state */2][/* showDetails23 */29];
        var tmp$4;
        if (match$8 !== 0) {
          var match$9 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId2Int - 1 | 0), exLev2Int - 1 | 0);
          var switcher$2 = match$9 - 2 | 0;
          if (switcher$2 > 2 || switcher$2 < 0) {
            tmp$4 = block36;
          } else {
            switch (switcher$2) {
              case 0 : 
                  tmp$4 = block32;
                  break;
              case 1 : 
                  tmp$4 = block33;
                  break;
              case 2 : 
                  tmp$4 = block34;
                  break;
              
            }
          }
        } else {
          tmp$4 = null;
        }
        var match$10 = self[/* state */2][/* preRunning */27];
        tmp$3 = React.createElement("div", {
              className: flexList
            }, React.createElement("div", {
                  className: initialBody
                }, tmp$4), React.createElement("div", {
                  className: flexList2
                }, React.createElement("div", {
                      className: countDown
                    }, match$10 !== 0 ? ReasonReact.element(/* None */0, /* None */0, Counter.make(self[/* state */2][/* preRunningCount */28], self[/* state */2][/* preRunningCount */28], /* true */1, /* array */[])) : ReasonReact.element(/* None */0, /* None */0, Counter3.make(self[/* state */2][/* duration */2], "Timer: ", self[/* state */2][/* count */30], /* false */0, /* array */[]))), React.createElement("div", {
                      className: buttonContainer
                    }, React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* FinishPair */7);
                            })
                        }, "Weiter"))));
      } else {
        var match$11 = self[/* state */2][/* showDetails23 */29];
        var tmp$5;
        if (match$11 !== 0) {
          var match$12 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId2Int - 1 | 0), exLev2Int - 1 | 0);
          var switcher$3 = match$12 - 2 | 0;
          if (switcher$3 > 2 || switcher$3 < 0) {
            tmp$5 = block36;
          } else {
            switch (switcher$3) {
              case 0 : 
                  tmp$5 = block32;
                  break;
              case 1 : 
                  tmp$5 = block33;
                  break;
              case 2 : 
                  tmp$5 = block34;
                  break;
              
            }
          }
        } else {
          tmp$5 = null;
        }
        tmp$3 = React.createElement("div", {
              className: flexList
            }, React.createElement("div", {
                  className: initialBody
                }, tmp$5), React.createElement("div", {
                  className: flexList2
                }, React.createElement("div", {
                      className: countDown
                    }, ReasonReact.element(/* None */0, /* None */0, Counter.make(self[/* state */2][/* duration */2], self[/* state */2][/* count */30], /* true */1, /* array */[]))), React.createElement("div", {
                      className: buttonContainer
                    }, React.createElement("button", {
                          className: Theme.simpleButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* SetRunning */3);
                            })
                        }, "Start"))));
      }
      var step3 = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: fullBox
              }, React.createElement("div", {
                    className: fullContainer
                  }, React.createElement("div", {
                        className: headBox
                      }, React.createElement("div", {
                            className: roundIconBox
                          }, React.createElement("img", {
                                className: roundIcon,
                                alt: "round",
                                src: Round_iconSvg
                              })), React.createElement("h1", {
                            className: infoHeaderH1
                          }, "Runde " + round), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übungspaar " + (String(intPair) + " / 3")), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übung " + (String(currentEx2) + ""))), React.createElement("div", {
                        className: workoutNameHeader
                      }, React.createElement("h2", {
                            className: infoHeaderH2
                          }, Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 1 | 0)), React.createElement("div", {
                            className: infoButton,
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* ToggleDetails23 */0);
                              })
                          }, React.createElement("img", {
                                className: infoIcon,
                                alt: "info",
                                src: Info_iconSvg
                              }))), tmp$3)));
      var weightEntryA = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx1) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 2 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exAInput */12],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExA */Block.__(2, [$$event.target.value]));
                  })
              }));
      var match$13 = self[/* state */2][/* error */32];
      var weightEntryB = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx2) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 1 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exBInput */14],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExB */Block.__(3, [$$event.target.value]));
                  })
              }), match$13 ? React.createElement("div", {
                  className: "failure"
                }, match$13[0]) : null);
      var weightEntryC = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx1) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 2 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exCInput */16],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExC */Block.__(4, [$$event.target.value]));
                  })
              }));
      var match$14 = self[/* state */2][/* error */32];
      var weightEntryD = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx2) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 1 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exDInput */18],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExD */Block.__(5, [$$event.target.value]));
                  })
              }), match$14 ? React.createElement("div", {
                  className: "failure"
                }, match$14[0]) : null);
      var weightEntryE = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx1) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 2 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exEInput */20],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExE */Block.__(6, [$$event.target.value]));
                  })
              }));
      var match$15 = self[/* state */2][/* error */32];
      var weightEntryF = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: inputHeaderContainer
              }, React.createElement("h4", {
                    className: inputHeader
                  }, "Übung " + (String(currentEx2) + " "), Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */6], (intPair << 1) - 1 | 0))), React.createElement("input", {
                className: inputField,
                pattern: "[0-9]*",
                placeholder: "WDH",
                type: "number",
                value: self[/* state */2][/* exFInput */22],
                onInput: (function ($$event) {
                    return Curry._1(self[/* send */4], /* ChangeExF */Block.__(7, [$$event.target.value]));
                  })
              }), match$15 ? React.createElement("div", {
                  className: "failure"
                }, match$15[0]) : null);
      var switcher$4 = intPair - 1 | 0;
      var tmp$6;
      if (switcher$4 > 2 || switcher$4 < 0) {
        tmp$6 = weightEntryA;
      } else {
        switch (switcher$4) {
          case 0 : 
              tmp$6 = weightEntryA;
              break;
          case 1 : 
              tmp$6 = weightEntryC;
              break;
          case 2 : 
              tmp$6 = weightEntryE;
              break;
          
        }
      }
      var switcher$5 = intPair - 1 | 0;
      var tmp$7;
      if (switcher$5 > 2 || switcher$5 < 0) {
        tmp$7 = weightEntryB;
      } else {
        switch (switcher$5) {
          case 0 : 
              tmp$7 = weightEntryB;
              break;
          case 1 : 
              tmp$7 = weightEntryD;
              break;
          case 2 : 
              tmp$7 = weightEntryF;
              break;
          
        }
      }
      var step4 = React.createElement("div", {
            className: flexList
          }, React.createElement("div", {
                className: fullBox
              }, React.createElement("div", {
                    className: fullContainer
                  }, React.createElement("div", {
                        className: headBox
                      }, React.createElement("div", {
                            className: roundIconBox
                          }, React.createElement("img", {
                                className: roundIcon,
                                alt: "round",
                                src: Round_iconSvg
                              })), React.createElement("h1", {
                            className: infoHeaderH1
                          }, "Runde " + round), React.createElement("h4", {
                            className: infoHeaderH4
                          }, "Übungspaar " + (String(intPair) + " / 3"))), React.createElement("div", {
                        className: workoutNameHeader
                      }, React.createElement("div", {
                            className: repEntryBox
                          }, React.createElement("h2", {
                                className: infoHeaderH2
                              }, "Super gemacht!"), React.createElement("div", {
                                className: repEntryText
                              }, "Wie viele Wiederholungen hast du in der gegebenen Zeit geschafft?"))), tmp$6, tmp$7, React.createElement("div", {
                        className: horizonBox
                      }, React.createElement("div", {
                            className: countDown
                          }, ReasonReact.element(/* None */0, /* None */0, Counter2.make((function () {
                                      return Curry._1(self[/* send */4], /* NextPairOrRoundOrFinish */8);
                                    }), 30, "Pause: ", /* array */[])))), React.createElement("div", {
                        className: buttonContainer
                      }, React.createElement("button", {
                            className: Theme.simpleButton(/* () */0),
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* NextPairOrRoundOrFinish */8);
                              })
                          }, "Weiter")))));
      var step5 = React.createElement("div", {
            className: flexList
          }, ReasonReact.element(/* None */0, /* None */0, Step5box.make(self[/* state */2][/* points */31], /* array */[])), React.createElement("div", {
                className: buttonContainer
              }, React.createElement("button", {
                    className: Theme.simpleButton(/* () */0),
                    onClick: (function () {
                        return ReasonReact.Router[/* push */0]("/dashboard");
                      })
                  }, "Dashboard")));
      var step6 = React.createElement("div", {
            className: step5Box
          }, React.createElement("div", {
                className: step5BoxInner1
              }, React.createElement("img", {
                    className: congratsIcon,
                    alt: "",
                    src: Congratulation_bgSvg
                  })), React.createElement("div", {
                className: step5BoxInner2
              }, React.createElement("h2", {
                    className: middleText
                  }, "Du hast soeben dein finales Workout\n          erfolgreich absolviert.")), React.createElement("div", {
                className: step5BoxInner3
              }, React.createElement("div", {
                    className: weightInputHeaderContainer
                  }, React.createElement("div", {
                        className: weightEntryText
                      }, "Trage jetzt dein aktuelles Gewicht ein!")), React.createElement("input", {
                    className: inputField,
                    pattern: "[0-9]*",
                    placeholder: "KG",
                    type: "number",
                    value: self[/* state */2][/* weightReductionInput */35],
                    onInput: (function ($$event) {
                        return Curry._1(self[/* send */4], /* ChangeFinalWeight */Block.__(0, [$$event.target.value]));
                      })
                  })), React.createElement("div", {
                className: buttonContainerCentered
              }, React.createElement("button", {
                    className: Theme.simpleButton(/* () */0),
                    onClick: (function () {
                        return Curry._1(self[/* send */4], /* FinalScreen */9);
                      })
                  }, "Weiter")));
      var match$16 = self[/* state */2][/* weightReduction */36];
      var tmp$8;
      if (match$16) {
        var value = match$16[0];
        tmp$8 = value >= 0 ? React.createElement("div", {
                className: finalVal
              }, "-" + (String(value) + " KG")) : null;
      } else {
        tmp$8 = null;
      }
      var step7 = React.createElement("div", {
            className: step5Box
          }, React.createElement("div", {
                className: step5BoxInner1
              }, ReasonReact.element(/* None */0, /* None */0, SvgAnim.make(/* array */[]))), tmp$8, React.createElement("div", {
                className: step5BoxInner2
              }, React.createElement("h2", {
                    className: middleText
                  }, "Super!"), React.createElement("div", {
                    className: weightInputHeaderContainer
                  }, React.createElement("div", {
                        className: finalText
                      }, "Herzlichen Glückwunsch zu deinem neuen Bikini-Body!"))), React.createElement("div", {
                className: buttonContainerCentered
              }, React.createElement("button", {
                    className: Theme.simpleButton(/* () */0),
                    onClick: (function () {
                        return ReasonReact.Router[/* push */0]("/dashboard");
                      })
                  }, "Dashboard")));
      var tmp$9;
      switch (step) {
        case "2" : 
            tmp$9 = step2;
            break;
        case "3" : 
            tmp$9 = step3;
            break;
        case "4" : 
            tmp$9 = step4;
            break;
        case "5" : 
            tmp$9 = step5;
            break;
        case "6" : 
            tmp$9 = step6;
            break;
        case "7" : 
            tmp$9 = step7;
            break;
        default:
          tmp$9 = step2;
      }
      return React.createElement("div", {
                  className: workout
                }, tmp$9);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* workoutIndex */Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout$1) - 1 | 0) | 0,
              /* levels */Caml_array.caml_array_get(Network.pullLevelConfig(/* () */0), Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout$1) - 1 | 0) | 0),
              /* duration */Storage.getDuration(/* () */0),
              /* allLevels */Network.pullLevelConfig(/* () */0),
              /* pairList : array */[
                "1",
                "1",
                "2",
                "2",
                "3",
                "3"
              ],
              /* showDetails : int array */[
                /* false */0,
                /* false */0
              ],
              /* currentWorkoutExercises */Seed.getWorkoutTitles(week, workout$1),
              /* currentWorkoutExercisesIds */Seed.getWorkoutIds(week, workout$1),
              /* exCur1Input */"",
              /* exCur1 */0,
              /* exCur2Input */"",
              /* exCur2 */0,
              /* exAInput */"",
              /* exA */0,
              /* exBInput */"",
              /* exB */0,
              /* exCInput */"",
              /* exC */0,
              /* exDInput */"",
              /* exD */0,
              /* exEInput */"",
              /* exE */0,
              /* exFInput */"",
              /* exF */0,
              /* hide1 : false */0,
              /* hide2 : false */0,
              /* running : false */0,
              /* preRunning : false */0,
              /* preRunningCount */-1,
              /* showDetails23 : false */0,
              /* count */Storage.getDuration(/* () */0),
              /* points */Network.calcPointsOverall(Network.pullPointsConfig(/* () */0)),
              /* error : None */0,
              /* intervalId */[/* None */0],
              /* interval2Id */[/* None */0],
              /* weightReductionInput */"",
              /* weightReduction */Storage.getWeightDiff(/* () */0)
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              var newrecord = state.slice();
              return /* Update */Block.__(0, [(newrecord[/* showDetails23 */29] = 1 - state[/* showDetails23 */29], newrecord)]);
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            var match = state[/* running */26];
                            switch (step) {
                              case "2" : 
                                  if (match !== 0) {
                                    console.log("enter press 2 true");
                                    return Curry._1(self[/* send */4], /* SecondPair */6);
                                  } else {
                                    console.log("enter press 2");
                                    return Curry._1(self[/* send */4], /* SetRunning */3);
                                  }
                              case "3" : 
                                  if (match !== 0) {
                                    return Curry._1(self[/* send */4], /* FinishPair */7);
                                  } else {
                                    console.log("enter press 3");
                                    return Curry._1(self[/* send */4], /* SetRunning */3);
                                  }
                              case "4" : 
                                  if (match !== 0) {
                                    return /* () */0;
                                  } else {
                                    return Curry._1(self[/* send */4], /* NextPairOrRoundOrFinish */8);
                                  }
                              default:
                                return /* () */0;
                            }
                          })]);
          case 2 : 
              var newrecord$1 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$1[/* showDetails */5] = /* int array */[
                            /* false */0,
                            /* false */0
                          ], newrecord$1[/* showDetails23 */29] = /* false */0, newrecord$1),
                        (function () {
                            return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (workout$1 + ("/" + (round + ("/" + (pair + "/2"))))))));
                          })
                      ]);
          case 3 : 
              var newrecord$2 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$2[/* running */26] = /* true */1, newrecord$2[/* preRunning */27] = /* true */1, newrecord$2[/* preRunningCount */28] = 3, newrecord$2[/* showDetails23 */29] = /* false */0, newrecord$2[/* count */30] = state[/* duration */2] + 3 | 0, newrecord$2),
                        (function (self) {
                            var x = new Audio(BeepMp3);
                            state[/* interval2Id */34][0] = /* Some */[setInterval((function () {
                                      return Curry._1(self[/* send */4], /* Tick */10);
                                    }), 1000)];
                            console.log("interval2id", state[/* interval2Id */34]);
                            state[/* intervalId */33][0] = /* Some */[setTimeout((function () {
                                      if (document.hidden) {
                                        return 0;
                                      } else {
                                        var playing2 = x.play();
                                        if (!(playing2 == null)) {
                                          playing2.then((function () {
                                                    console.log("promise2 returned");
                                                    return Promise.resolve(/* () */0);
                                                  })).catch((function (err) {
                                                  console.log("Audio promise2 failure ", err);
                                                  return Promise.resolve(/* () */0);
                                                }));
                                        }
                                        return /* () */0;
                                      }
                                    }), Caml_int32.imul(state[/* duration */2], 1000) + 3000 | 0)];
                            return /* () */0;
                          })
                      ]);
          case 4 : 
              var newrecord$3 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$3[/* running */26] = /* true */1, newrecord$3[/* preRunning */27] = /* true */1, newrecord$3[/* preRunningCount */28] = 3, newrecord$3[/* showDetails23 */29] = /* false */0, newrecord$3),
                        (function () {
                            console.log("setting prerunning");
                            return /* () */0;
                          })
                      ]);
          case 5 : 
              var newrecord$4 = state.slice();
              return /* Update */Block.__(0, [(newrecord$4[/* count */30] = 0, newrecord$4)]);
          case 6 : 
              var newrecord$5 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$5[/* running */26] = /* false */0, newrecord$5[/* preRunning */27] = /* false */0, newrecord$5[/* showDetails23 */29] = /* false */0, newrecord$5),
                        (function () {
                            console.log("Second Pair starting");
                            var match = state[/* intervalId */33][0];
                            if (match) {
                              clearTimeout(match[0]);
                              state[/* intervalId */33][0] = /* None */0;
                            }
                            var match$1 = state[/* interval2Id */34][0];
                            if (match$1) {
                              clearInterval(match$1[0]);
                              state[/* interval2Id */34][0] = /* None */0;
                            }
                            return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (workout$1 + ("/" + (round + ("/" + (pair + "/3"))))))));
                          })
                      ]);
          case 7 : 
              var newrecord$6 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$6[/* hide1 */24] = /* false */0, newrecord$6[/* hide2 */25] = /* false */0, newrecord$6),
                        (function () {
                            var match = state[/* intervalId */33][0];
                            if (match) {
                              clearTimeout(match[0]);
                              state[/* intervalId */33][0] = /* None */0;
                            }
                            var match$1 = state[/* interval2Id */34][0];
                            if (match$1) {
                              clearInterval(match$1[0]);
                              state[/* interval2Id */34][0] = /* None */0;
                            }
                            return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (workout$1 + ("/" + (round + ("/" + (pair + "/4"))))))));
                          })
                      ]);
          case 8 : 
              var routeStart = "/week/" + (week + ("/workout/" + (workout$1 + "/")));
              var reps1;
              switch (pair) {
                case "1" : 
                    var match = +(state[/* exCur1 */9] === 0);
                    reps1 = match !== 0 ? state[/* exA */13] : state[/* exCur1 */9];
                    break;
                case "2" : 
                    var match$1 = +(state[/* exCur1 */9] === 0);
                    reps1 = match$1 !== 0 ? state[/* exC */17] : state[/* exCur1 */9];
                    break;
                case "3" : 
                    var match$2 = +(state[/* exCur1 */9] === 0);
                    reps1 = match$2 !== 0 ? state[/* exE */21] : state[/* exCur1 */9];
                    break;
                default:
                  var match$3 = +(state[/* exCur1 */9] === 0);
                  reps1 = match$3 !== 0 ? state[/* exA */13] : state[/* exCur1 */9];
              }
              var reps2;
              switch (pair) {
                case "1" : 
                    var match$4 = +(state[/* exCur2 */11] === 0);
                    reps2 = match$4 !== 0 ? state[/* exB */15] : state[/* exCur2 */11];
                    break;
                case "2" : 
                    var match$5 = +(state[/* exCur2 */11] === 0);
                    reps2 = match$5 !== 0 ? state[/* exD */19] : state[/* exCur2 */11];
                    break;
                case "3" : 
                    var match$6 = +(state[/* exCur2 */11] === 0);
                    reps2 = match$6 !== 0 ? state[/* exF */23] : state[/* exCur2 */11];
                    break;
                default:
                  var match$7 = +(state[/* exCur1 */9] === 0);
                  reps2 = match$7 !== 0 ? state[/* exA */13] : state[/* exCur2 */11];
              }
              Network.storePointsAndReps(state[/* workoutIndex */0], Caml_format.caml_int_of_string(round), Caml_format.caml_int_of_string(pair), reps1, reps2, state[/* levels */1]);
              var nextRoute;
              var exit = 0;
              if (round === "4" && pair === "3") {
                Storage.clearLoc(/* () */0);
                Network.storeCompletedWorkout(state[/* workoutIndex */0]);
                if (Storage.calculateProgramDay(/* () */0) === -1) {
                  console.log("saving first workout date");
                  Network.saveFirstWorkoutDate(/* () */0);
                }
                nextRoute = week === "4" && Network.check16Completed(/* () */0) ? routeStart + "4/3/6" : routeStart + "4/3/5";
              } else {
                exit = 1;
              }
              if (exit === 1) {
                nextRoute = pair === "3" ? routeStart + (String(Caml_format.caml_int_of_string(round) + 1 | 0) + "/1/2") : routeStart + (round + ("/" + (String(Caml_format.caml_int_of_string(pair) + 1 | 0) + "/2")));
              }
              var newrecord$7 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$7[/* exCur1Input */8] = turnBackToString(0), newrecord$7[/* exCur1 */9] = 0, newrecord$7[/* exCur2Input */10] = turnBackToString(0), newrecord$7[/* exCur2 */11] = 0, newrecord$7[/* count */30] = state[/* duration */2], newrecord$7[/* points */31] = Network.calcPointsOverall(Network.pullPointsConfig(/* () */0)), newrecord$7),
                        (function () {
                            console.log("nextroute", nextRoute);
                            return ReasonReact.Router[/* push */0](nextRoute);
                          })
                      ]);
          case 9 : 
              var routeStart$1 = "/week/" + (week + ("/workout/" + (workout$1 + "/")));
              var nextRoute$1 = routeStart$1 + "4/3/7";
              Storage.clearLoc(/* () */0);
              var newrecord$8 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$8[/* exCur1 */9] = 0, newrecord$8),
                        (function () {
                            var match = state[/* weightReduction */36];
                            if (match) {
                              Storage.storeWeightDiff(match[0]);
                            }
                            return ReasonReact.Router[/* push */0](nextRoute$1);
                          })
                      ]);
          case 10 : 
              var match$8 = state[/* count */30];
              if (match$8 !== 0) {
                var newrecord$9 = state.slice();
                return /* UpdateWithSideEffects */Block.__(3, [
                          (newrecord$9[/* count */30] = state[/* count */30] - 1 | 0, newrecord$9),
                          (function (self) {
                              return Curry._1(self[/* send */4], /* Tick2 */11);
                            })
                        ]);
              } else {
                var newrecord$10 = state.slice();
                return /* UpdateWithSideEffects */Block.__(3, [
                          (newrecord$10[/* preRunning */27] = /* false */0, newrecord$10),
                          (function () {
                              var match = state[/* interval2Id */34][0];
                              if (match) {
                                clearInterval(match[0]);
                                state[/* interval2Id */34][0] = /* None */0;
                                return /* () */0;
                              } else {
                                return /* () */0;
                              }
                            })
                        ]);
              }
          case 11 : 
              var match$9 = state[/* preRunningCount */28];
              var exit$1 = 0;
              var switcher = match$9 + 1 | 0;
              if (switcher > 2 || switcher < 0) {
                exit$1 = 1;
              } else {
                switch (switcher) {
                  case 0 : 
                      return /* NoUpdate */0;
                  case 1 : 
                      exit$1 = 1;
                      break;
                  case 2 : 
                      var newrecord$11 = state.slice();
                      return /* Update */Block.__(0, [(newrecord$11[/* running */26] = /* true */1, newrecord$11[/* preRunning */27] = /* false */0, newrecord$11[/* preRunningCount */28] = -1, newrecord$11)]);
                  
                }
              }
              if (exit$1 === 1) {
                var newrecord$12 = state.slice();
                return /* Update */Block.__(0, [(newrecord$12[/* preRunningCount */28] = state[/* preRunningCount */28] - 1 | 0, newrecord$12)]);
              }
              break;
          case 12 : 
              var newrecord$13 = state.slice();
              return /* Update */Block.__(0, [(newrecord$13[/* running */26] = /* false */0, newrecord$13[/* showDetails23 */29] = /* false */0, newrecord$13[/* count */30] = state[/* duration */2], newrecord$13)]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var text = action[0];
              var validInt = checkForWeightInt(text);
              var validIntOpt = checkForWeightIntOpt(text);
              var oldWeight = Storage.getWeight(/* () */0);
              var weightReduction = validIntOpt ? /* Some */[oldWeight - validIntOpt[0] | 0] : /* None */0;
              var newrecord$14 = state.slice();
              return /* Update */Block.__(0, [(newrecord$14[/* weightReductionInput */35] = turnBackToString(validInt), newrecord$14[/* weightReduction */36] = weightReduction, newrecord$14)]);
          case 1 : 
              var item = action[0];
              var showDetailsNew = $$Array.mapi((function (index, oldEntry) {
                      var match = +(index === item);
                      if (match !== 0) {
                        return 1 - oldEntry;
                      } else {
                        return /* false */0;
                      }
                    }), state[/* showDetails */5]);
              var newrecord$15 = state.slice();
              return /* Update */Block.__(0, [(newrecord$15[/* showDetails */5] = showDetailsNew, newrecord$15)]);
          case 2 : 
              var validInt$1 = checkForInt(action[0]);
              var newrecord$16 = state.slice();
              return /* Update */Block.__(0, [(newrecord$16[/* exCur1Input */8] = turnBackToString(validInt$1), newrecord$16[/* exCur1 */9] = validInt$1, newrecord$16[/* exAInput */12] = turnBackToString(validInt$1), newrecord$16[/* exA */13] = validInt$1, newrecord$16)]);
          case 3 : 
              var validInt$2 = checkForInt(action[0]);
              var newrecord$17 = state.slice();
              return /* Update */Block.__(0, [(newrecord$17[/* exCur2Input */10] = turnBackToString(validInt$2), newrecord$17[/* exCur2 */11] = validInt$2, newrecord$17[/* exBInput */14] = turnBackToString(validInt$2), newrecord$17[/* exB */15] = validInt$2, newrecord$17)]);
          case 4 : 
              var validInt$3 = checkForInt(action[0]);
              var newrecord$18 = state.slice();
              return /* Update */Block.__(0, [(newrecord$18[/* exCur1Input */8] = turnBackToString(validInt$3), newrecord$18[/* exCur1 */9] = validInt$3, newrecord$18[/* exCInput */16] = turnBackToString(validInt$3), newrecord$18[/* exC */17] = validInt$3, newrecord$18)]);
          case 5 : 
              var validInt$4 = checkForInt(action[0]);
              var newrecord$19 = state.slice();
              return /* Update */Block.__(0, [(newrecord$19[/* exCur2Input */10] = turnBackToString(validInt$4), newrecord$19[/* exCur2 */11] = validInt$4, newrecord$19[/* exDInput */18] = turnBackToString(validInt$4), newrecord$19[/* exD */19] = validInt$4, newrecord$19)]);
          case 6 : 
              var validInt$5 = checkForInt(action[0]);
              var newrecord$20 = state.slice();
              return /* Update */Block.__(0, [(newrecord$20[/* exCur1Input */8] = turnBackToString(validInt$5), newrecord$20[/* exCur1 */9] = validInt$5, newrecord$20[/* exEInput */20] = turnBackToString(validInt$5), newrecord$20[/* exE */21] = validInt$5, newrecord$20)]);
          case 7 : 
              var validInt$6 = checkForInt(action[0]);
              var newrecord$21 = state.slice();
              return /* Update */Block.__(0, [(newrecord$21[/* exCur2Input */10] = turnBackToString(validInt$6), newrecord$21[/* exCur2 */11] = validInt$6, newrecord$21[/* exFInput */22] = turnBackToString(validInt$6), newrecord$21[/* exF */23] = validInt$6, newrecord$21)]);
          case 8 : 
              var item$1 = action[0];
              console.log("hiding: ", item$1);
              if (item$1 !== 1) {
                var newrecord$22 = state.slice();
                return /* Update */Block.__(0, [(newrecord$22[/* hide2 */25] = /* true */1, newrecord$22)]);
              } else {
                var newrecord$23 = state.slice();
                return /* Update */Block.__(0, [(newrecord$23[/* hide1 */24] = /* true */1, newrecord$23)]);
              }
          
        }
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return ReasonReact.Router[/* watchUrl */1]((function () {
                                  return Curry._1(self[/* send */4], /* ClearState */12);
                                }));
                  }),
                ReasonReact.Router[/* unwatchUrl */2]
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.checkForInt = checkForInt;
exports.checkForWeightInt = checkForWeightInt;
exports.checkForWeightIntOpt = checkForWeightIntOpt;
exports.turnBackToString = turnBackToString;
exports.text = text;
exports.$$window = $$window;
exports.$$document = $$document;
exports.JsAudio = JsAudio;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/workout.re
// module id = 121
// module chunks = 0